/**
 * Toggle preloader in section
 * @param {Node} $container - Section container
 * @param {Boolean} toggle
 */
export const preloader = ($container, toggle) => {
  $container.find('.js-preloader').toggleClass('show', toggle);
}
